import { configureStore } from '@reduxjs/toolkit'
import userReducer from "./userSlice";
import organizationReducer from "./organizationSlice"
import clientReducer from "./clientSlice";
import vendorReducer from "./vendorSlice"
import flaggedItemsReducer from "./flaggedItemsSlice"

const store = configureStore({
  reducer: {
    user: userReducer,
    organization: organizationReducer,
    client: clientReducer,
    vendor: vendorReducer,
    flaggedItems: flaggedItemsReducer,
  }
})

export default store
